import { ResultWithCountsDTO } from '@atlassiansox/phobos-client-ts/src/models/ResultWithCountsDTO';
import {
  ResultDataPointDTO,
  SloQualityResultDTO,
} from '@atlassiansox/phobos-client-ts/dist/models';
import { SloDTO } from '@atlassiansox/phobos-client-ts';

import { SloQualityCheckerId } from '@/constants';

/**
 * If there are no events then we default to 100% SLI
 * @param goodCount
 * @param badCount
 * @param result
 */
export function getResult({ goodCount, badCount, result }: ResultWithCountsDTO) {
  if (goodCount === undefined || badCount === undefined) return result;
  return !result && goodCount + badCount === 0 ? 1 : result;
}

const applyDataPointDefaults = (dataPoint: ResultDataPointDTO): ResultDataPointDTO => ({
  ...dataPoint,
  daily: {
    ...dataPoint.daily,
    result: getResult(dataPoint.daily ?? {}),
  },
});

/**
 * Creates a new SloDTO with default values applied
 * @param sloDTO
 */
export const applySloDefaults = (sloDTO: SloDTO): SloDTO => {
  if (!sloDTO.performance) return sloDTO;
  return {
    ...sloDTO,
    performance: {
      ...sloDTO.performance,
      dataPoints: sloDTO.performance?.dataPoints.map(applyDataPointDefaults),
    },
  } as SloDTO;
};

/**
 * Checks if a SLO uses high cardinality metrics
 * @param sloDTO
 */
export const isHighCardinality = (quality?: SloQualityResultDTO): boolean =>
  quality?.sloQualityResultItems?.some(
    item => item.qualityCheckerId === SloQualityCheckerId.HighCardinality && item.hasQualityIssue
  ) ?? false;
